export enum RestrictedDestinations {
  HAVANA = 'HAV',
  VENEZUELA = 'VEN',
}
